/**
 * MovementTrace — Trazabilidad del movimiento (V1.45)
 * Creado por / Fecha creación / Última modificación / Modificado por.
 */
import { useFamilyMembers } from "./MemberSelect";

const fmt = (iso) => {
  if (!iso) return null;
  try { return new Date(iso).toLocaleString("es-ES", { dateStyle: "short", timeStyle: "short" }); } catch { return iso; }
};

export default function MovementTrace({ doc }) {
  const members = useFamilyMembers();
  if (!doc || (!doc.created_by && !doc.updated_by && !doc.member_id)) return null;
  const owner = doc.member_id ? members.find((m) => m.id === doc.member_id) : null;
  return (
    <div className="mt-3 pt-2 border-t border-border text-[11px] text-muted-foreground space-y-0.5" data-testid="movement-trace">
      <div>Pertenece a: <span className="font-medium text-foreground">{owner ? owner.name : "Común (familiar)"}</span></div>
      {doc.created_by && <div>Creado por {doc.created_by}{doc.created_at ? ` · ${fmt(doc.created_at)}` : ""}</div>}
      {doc.updated_by && <div>Última modificación: {doc.updated_by}{doc.updated_at ? ` · ${fmt(doc.updated_at)}` : ""}</div>}
    </div>
  );
}
